import { useContext } from 'react';

import { TelehealthSessionContext } from '../../components/TelehealthSessionProvider';

const useTelehealthSessionContext = () => {
  const context = useContext(TelehealthSessionContext);

  if (typeof context === 'undefined') {
    throw new Error('useTelehealthSessionContext must be used within TelehealthSessionContextProvider');
  }

  return context;
};

export default useTelehealthSessionContext;
